


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { DeviceForm } from '@/models/config'

// Components
import { FormCreateEditDevice } from '@/components/config'

@Component({
    name: 'ModalCreateEditDevice',
    components: {
        FormCreateEditDevice
    }
})
export default class ModalCreateEditDevice extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) device!: DeviceForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Nuevo Dispositivo'
        }
        return 'Editar Dispositivo'
    }
}
